export default {
    namespaced: true,
    state: {
        cart: [],
        cartGroups: [],
        error: false
    },
    getters: {
        cartCount(state) {
            return state.cart.length
        },
        error(state) {
            return state.error
        },
        cartGroupsCount(state) {
            return state.cartGroups.length
        },
        // общее количество изделий
        cartTotalCount(state) {
            return state.cart.reduce(
                (acc, item) => acc + parseInt(item.pivot.Quantity, 10),
                0
            )
        },
        cartTotalSum(state) {
            return state.cart.reduce(
                (acc, item) =>
                    acc +
                    (parseFloat(item.Price) || 0) *
                        parseFloat(item.pivot.Quantity),
                0
            )
        },
        //кол-во изделий бренда
        cartCountByBrand: state => id => {
            return state.cart
                .filter(product => product.BrandID === id)
                .reduce(
                    (acc, item) => acc + parseInt(item.pivot.Quantity, 10),
                    0
                )
        },
        cartSumByBrand: state => id => {
            return state.cart
                .filter(product => product.BrandID === id)
                .reduce(
                    (acc, item) =>
                        acc +
                        (parseFloat(item.Price) || 0) *
                            parseFloat(item.pivot.Quantity),
                    0
                )
        },
        productInCart: state => id => {
            return state.cart.find(product => product.ItemID === id)
        },
        cartIsEmpty(state) {
            return state.cart.length === 0
        }
    },
    mutations: {
        SET_CART(state, cartData) {
            const cartItems = []

            state.cartGroups = cartData

            cartData.map(brand => {
                brand.Items.map(item => {
                    cartItems.push(item)
                })
            })

            state.cart = cartItems
        },
        SET_ERROR(state, status) {
            state.error = status
        }
    },
    actions: {
        getCart({ commit }) {
            commit('SET_ERROR', false)
            return this.$axios
                .get(`/retailer/cart`)
                .then(({ data }) => {
                    commit('SET_CART', data)
                })
                .catch(() => {
                    commit('SET_ERROR', true)
                })
        },
        addToCart({ commit }, productID) {
            return this.$axios.post(`/retailer/cart/item/${productID}`)
        },
        deleteFromCart({ commit }, productID) {
            return this.$axios.delete(`/retailer/cart/item/${productID}`)
        },
        changeItemQuantity(
            { dispatch },
            { productID, quantity, comment = '' }
        ) {
            return this.$axios
                .patch(`/retailer/cart/item/${productID}`, {
                    Quantity: quantity,
                    Comment: comment
                })
                .then(() => {
                    dispatch('getCart')
                })
        },
        addAllItemsFromList({ dispatch }, listID) {
            return this.$axios
                .post(`/retailer/cart/list/${listID}`)
                .then(() => {
                    dispatch('getCart')
                })
        },
        clearCart({ dispatch }) {
            return this.$axios.delete(`/retailer/cart`).then(() => {
                dispatch('getCart')
            })
        }
    }
}
